import { motion } from "framer-motion";
import { Facebook, Youtube, Instagram, Mail } from "lucide-react";

const FooterSection = () => {
  const socialLinks = [
    { icon: Youtube, href: "https://www.youtube.com/channel/UCzJ61lnyiUJmZJwuoH7jlEA", label: "YouTube" },
    { icon: Facebook, href: "https://www.facebook.com/groups/2104130453117193/", label: "Facebook" },
    { icon: Instagram, href: "https://www.instagram.com/gillesdelieuze/", label: "Instagram" },
    { icon: Mail, href: "mailto:contact@gillesdelieuze.com", label: "Email" },
  ];

  return (
    <footer
      data-testid="footer-section"
      className="relative py-16 overflow-hidden"
      style={{ background: "#030014" }}
    >
      {/* Top Border */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-purple-500/50 to-transparent" />

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          {/* Logo/Brand */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h3
              className="text-3xl font-light mb-2"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              <span className="text-gradient-cosmic">Quantic Revolution</span>
            </h3>
            <p className="text-slate-500 text-sm">par Gilles Delieuze</p>
          </motion.div>

          {/* Social Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className="flex justify-center gap-4 my-8"
          >
            {socialLinks.map((social, index) => {
              const Icon = social.icon;
              return (
                <a
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  data-testid={`social-link-${social.label.toLowerCase()}`}
                  className="w-10 h-10 rounded-full bg-indigo-950/50 border border-indigo-500/20 flex items-center justify-center text-slate-400 hover:text-cyan-400 hover:border-cyan-500/40 transition-all"
                >
                  <Icon className="w-5 h-5" />
                </a>
              );
            })}
          </motion.div>

          {/* Copyright */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
            className="text-slate-600 text-sm space-y-2"
          >
            <p>© 2024 GILLES DELIEUZE — Tous droits réservés</p>
            <p className="text-xs max-w-2xl mx-auto leading-relaxed">
              Ce site ne fait pas partie du site YouTube™️, Google™️, Facebook™️, Google Inc. ou Facebook Inc. 
              De plus, ce site n'est PAS approuvé par YouTube™️, Google™️ ou Facebook™️ en aucune façon.
            </p>
          </motion.div>

          {/* Back to Top */}
          <motion.button
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.5 }}
            viewport={{ once: true }}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            data-testid="back-to-top-button"
            className="mt-8 text-slate-500 hover:text-cyan-400 text-sm transition-colors"
          >
            ↑ Retour en haut
          </motion.button>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
